import { Box, Button, Card, CardContent, CardMedia, Divider, Drawer, Grid, Typography ,Paper} from "@mui/material";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import SquareIcon from '@mui/icons-material/Square';
import {styled} from '@mui/material/styles';
import OverviewCard from "./OverviewCard";
import AlertsDialog from "./AlertsDialog";
import { MakerData } from "../types/type";
import React, { RefObject, useEffect, useState } from "react";
import { useRecoilState,useRecoilValue } from "recoil"
import { Bookmarks, CurrentAmount, CurrentEmission, CurrentMaker, CurrentPoint, RelevantMarkers} from "../store/currentState";
import { useNavigate } from 'react-router-dom'
import { setBookmarkApi, deleteBookmarkApi } from "../services/api/api";
import { useCookies } from "react-cookie";
import { copyTextToClipboard } from "../hooks/useFunction";
import AlertsSnackbar from "./AlertsSnackbar";
import CardPagination from "./CardPagination";
import { useTranslation } from 'react-i18next';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import UAParser from 'ua-parser-js';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#4B4B4B',
    ...theme.typography.body2,
    textAlign: 'center',
    color: "white",
    width: "20vw",
    fontSize: "11px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: "1px"
}));

function BottomDrawer(props: { 
    openBottomDrawer: boolean,
    setOpenBottomDrawer:React.Dispatch<React.SetStateAction<boolean>>,
    bottomDrawerRef:RefObject<HTMLDivElement>,
    handleBackClick:() => void,
    handleCardClick:(targetMarker:MakerData) => void
    }): JSX.Element {

    const {
        openBottomDrawer,
        setOpenBottomDrawer,
        bottomDrawerRef,
        handleBackClick,
        handleCardClick
    } = props

    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['recotech_mapapps_token']);
    const [isWaitingResponse, setIsWaitingResponse] = useState<boolean>(false);

    const relevantMarkers = useRecoilValue(RelevantMarkers);
    const marker = useRecoilValue(CurrentMaker);
    const [bookmarks, setBookmarks] = useRecoilState(Bookmarks);
    const [isBookmark, setIsBookmark] = useState<boolean>(false);

    // const [point, setPoint] = useRecoilState(CurrentPoint);
    const [amount, setAmount] = useRecoilState(CurrentAmount);
    const [emission, setEmission] = useRecoilState(CurrentEmission);  
  
    //SnackBarの設定
    const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
    const [alertsMessage, setAlertsMessage] = useState<string>("");
    const [severity, setSeverity] = useState< "error" | "success" >("error");

    const [page, setPage] = useState(1)

    const { t } = useTranslation();

    //ブックマークに入っているか確認
    useEffect(() => {
      if(marker !== null){
        if (bookmarks.includes(marker!.id!)){
          setIsBookmark(true)
        }else{
          setIsBookmark(false)
        }
      }
    }, [marker]); 

    const [openBookmarkDialog, setOpenBookMarkDialog] = useState<boolean>(false);
    const handleBookmarkAgreeClick = (async (isBookmark:boolean,targetMarker:MakerData) => {
      if(isBookmark){
        //ブックマークから削除
        const res = await deleteBookmarkApi(cookies.recotech_mapapps_token,targetMarker.id!,setAlertsMessage,setSeverity,setOpenSnackbar,setIsWaitingResponse)
        if(res){
          //登録後の処理
          setBookmarks(res)
        }else{
          //登録失敗の処理
        }
      }else{
        //ブックマークに登録
        const res = await setBookmarkApi(cookies.recotech_mapapps_token,targetMarker.id!,setAlertsMessage,setSeverity,setOpenSnackbar,setIsWaitingResponse)
        if(res){
          //登録後の処理
          setBookmarks(res)
        }else{
          //登録失敗の処理
        }
      }
      setOpenBookMarkDialog(false)      
      handleBackClick()
    })

    const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
    const handleEditAgreeClick = ((targetMarker:MakerData) => {
      navigate('/addplace',{state: targetMarker})
      setOpenEditDialog(false)
    })

    const getDeviceType = () => {
      const parser = new UAParser();
      const device = parser.getDevice();
      const deviceType = device.type;
      return deviceType;
    };


    const handleWhatsAppClick = (whatsappNumber: string) => {
      const deviceType = getDeviceType();
      const parser = new UAParser();
      const os = parser.getOS();
      
      const formattedNumber = whatsappNumber.startsWith('+') ? whatsappNumber : `+${whatsappNumber}`;
      const cleanNumber = formattedNumber.replace(/[^0-9+]/g, '');
      
      if (deviceType === 'mobile' || deviceType === 'tablet') {
        const whatsappUrl = `whatsapp://send?phone=${cleanNumber}`;
        const storeUrl = os.name?.toLowerCase().includes('ios') 
          ? 'https://apps.apple.com/app/whatsapp-messenger/id310633997'
          : 'https://play.google.com/store/apps/details?id=com.whatsapp';
        
        const timeout = setTimeout(() => {
          window.location.href = storeUrl;
        }, 2500);
  
        window.location.href = whatsappUrl;
        
        window.addEventListener('blur', () => {
          clearTimeout(timeout);
        });
      } else {
        window.open(`https://web.whatsapp.com/send?phone=${cleanNumber}`, '_blank');
      }
    };    


    return (
      <>
      <AlertsDialog
        openDialog={openBookmarkDialog}
        setOpenDialog={setOpenBookMarkDialog}
        handleAgreeClick={()=>handleBookmarkAgreeClick(isBookmark,marker!)}
        dialogTitle={(isBookmark)?t('component.bottomDrawer.bookmark.remove'):t('component.bottomDrawer.bookmark.add')}
        dialogMessage={(isBookmark)?t('component.bottomDrawer.bookmark.removeConfirmation'):t('component.bottomDrawer.bookmark.addConfirmation')}
        isWaitingResponse={isWaitingResponse}
      />
      <AlertsDialog
        openDialog={openEditDialog}
        setOpenDialog={setOpenEditDialog}
        handleAgreeClick={()=>handleEditAgreeClick(marker!)}
        dialogTitle={t('component.bottomDrawer.collectionPoint.edit')}
        dialogMessage={t('component.bottomDrawer.collectionPoint.editConfirmation')}
        isWaitingResponse={isWaitingResponse}
      />
      <AlertsSnackbar
        openSnackbar={openSnackbar}
        setOpenSnackbar={setOpenSnackbar}
        vertical={"bottom"}
        severity={severity}
        message={alertsMessage}
      />
      <Drawer
        sx={{zIndex: 1302}}
        anchor={'bottom'}
        open={openBottomDrawer}
        onClose={() => setOpenBottomDrawer(false)}
      >
        <Box
          ref={bottomDrawerRef}
          sx={{ width: "100vw", height: "100vh", bgcolor: 'background.paper' ,overflowY: "auto",position: "relative"}}
        >
          <Box
            sx={{position: "absolute" ,top: "3%",left: "3%"}}
          >
            <ArrowBackIosNewIcon
              onClick={() => handleBackClick()}
              sx={{backgroundColor: 'rgba(221,221,221,0.5)', borderRadius: "50%", padding: "5px"}}
          />
          </Box>
          <Card>
            <CardMedia
              component="img"
              height="194"
              image={`${marker?.imageUrl}`}
              alt="Paella dish"
            />
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexDirection="row"          
              >
                <Typography gutterBottom variant="h6" component="div">
                  {marker?.name}
                </Typography>
                {cookies.recotech_mapapps_token?
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="end"
                    flexDirection="row"
                  >
                    <EditLocationAltIcon
                      sx={{marginRight: "10px"}}
                      onClick={() => setOpenEditDialog(true)}
                    />
                      {(isBookmark)?
                        <BookmarkAddedIcon
                          sx={{color: "#EF4868"}}
                          onClick={() => setOpenBookMarkDialog(true)}
                        />                   
                      :
                        <BookmarkIcon
                          onClick={() => setOpenBookMarkDialog(true)}
                        />          
                      }
                  </Box>
                :<></>
                }
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                flexDirection="row"
                onClick={() => {
                  copyTextToClipboard(`${marker?.zipCode} ${marker?.address}`)
                  setAlertsMessage(t('component.bottomDrawer.collectionPoint.addressCopied'))
                  setSeverity("success")
                  setOpenSnackbar(true)
                }}
              >
                <LocationOnIcon
                  sx={{marginRight: "10px"}}
                />
                <Typography variant="body2" color="text.secondary">
                    {`${marker?.zipCode} ${marker?.address}`}
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box
                width="100%"
                height="50px"
                marginTop={1}
                >
                  <Button
                    fullWidth
                    sx={{color: "white", backgroundColor: "#4B4B4B"}}
                    variant="contained"
                    target="_blank"
                    href={`https://www.google.com/maps/dir/?api=1&destination=${marker?.latitude},${marker?.longitude}`}
                  >{t('component.bottomDrawer.collectionPoint.findRoute')}</Button>
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                flexDirection="row"          
              >
                <LocalPhoneIcon
                  sx={{marginRight: "10px"}}
                />
                <Typography variant="body2" color="text.secondary">
                  {
                    marker && marker?.phoneNumber
                      ? marker?.phoneNumber
                      : t('component.bottomDrawer.collectionPoint.noPhoneNumber')
                  }
                </Typography>           
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <WhatsAppIcon sx={{ mr: 1 }} />
                <Typography 
                  variant="body2" 
                  color="text.secondary"
                  onClick={() => marker?.whatsappNumber && handleWhatsAppClick(marker.whatsappNumber)}
                  sx={{ 
                    cursor: marker?.whatsappNumber ? 'pointer' : 'default',
                    textDecoration: marker?.whatsappNumber ? 'underline' : 'none'
                  }}
                >
                  {marker?.whatsappNumber || t('component.bottomDrawer.collectionPoint.noWhatsAppNumber')}
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                flexDirection="row"
                marginTop={3}
                marginBottom={0.5}
              >
                <SquareIcon fontSize="small" sx={{marginRight: "10px"}}
                />
                <Typography variant="body2" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.resources.title')}
                </Typography>           
              </Box>
              
              <Divider/>
              <Box
                marginTop={1}
                marginBottom={1}
              >
                <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                {marker?.categoryNames.map((item, index) => (
                  <Grid item xs={6} key={`grid${index}`}>
                    <Item key={`Item${index}`} sx={{width:"45vw",fontSize:"14px"}}>{item}</Item>
                  </Grid>
                ))}
                </Grid>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                flexDirection="row"
                marginTop={3}
                marginBottom={0.5}
              >
                <SquareIcon fontSize="small" sx={{marginRight: "10px"}}
                />
                <Typography variant="body2" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.resources.statistics')}
                </Typography>           
              </Box>
  
              <Divider/>
              <Box
                display="flex"
                flexDirection="row"
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  flexBasis={"25%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.resources.collectionAmount')}
                  </Typography>
                </Box>
                <Box
                  flexBasis={"75%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                    {amount} kg
                  </Typography>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  flexBasis={"25%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.resources.co2Reduction')}
                  </Typography>
                </Box>
                <Box
                  flexBasis={"75%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                    {emission} CO₂-kg
                  </Typography>
                </Box>
              </Box>
              {/* <Box
                display="flex"
                flexDirection="row"
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  flexBasis={"25%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  配布済pt
                  </Typography>
                </Box>
                <Box
                  flexBasis={"75%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                    {point} pt
                  </Typography>
                </Box>
              </Box>                 */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                flexDirection="row"
                marginTop={3}
                marginBottom={0.5}
              >
                <SquareIcon fontSize="small" sx={{marginRight: "10px"}}/>
                <Typography variant="body2" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.info.title')}
                </Typography>
              </Box>
  
              <Divider/>
              <Box
                display="flex"
                flexDirection="row"
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  flexBasis={"20%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.info.description')}
                  </Typography>
                </Box>
                <Box
                  flexBasis={"80%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                    {
                      marker && marker?.description
                        ? marker?.description
                        : t('component.bottomDrawer.info.noDescription')
                    }
                  </Typography>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  flexBasis={"20%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.info.businessHours')}
                  </Typography>
                </Box>
                <Box
                  flexBasis={"80%"}
                >
                <Typography variant="caption" sx={{ fontWeight:"bold" }}>
                  {
                    marker && marker.businessHours
                      ? marker.businessHours.split("\n").map((item, index) => {
                          return (
                            <React.Fragment key={index}>{item}<br /></React.Fragment>
                          );
                        })
                      : t('component.bottomDrawer.info.noBusinessHours')
                  }
                </Typography>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                marginTop={1}
                marginBottom={1}
              >
                <Box
                  flexBasis={"20%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.info.closedDays')}
                  </Typography>
                </Box>
                <Box
                  flexBasis={"80%"}
                >
                  <Typography variant="caption" sx={{fontWeight:"bold"}}>
                  {
                    marker && marker?.regularHolidays
                      ? marker?.regularHolidays
                      : t('component.bottomDrawer.info.noClosedDays')
                  }
                  </Typography>
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                flexDirection="row"
                marginTop={3}
                marginBottom={0.5}
              >
                <SquareIcon fontSize="small" sx={{marginRight: "10px"}}/>
                <Typography variant="body2" sx={{fontWeight:"bold"}}>
                  {t('component.bottomDrawer.info.otherLocations')}
                </Typography>
              </Box>
  
              <Divider/>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
              >
                {relevantMarkers?.filter((marker,index)=>{ // ページネーション用のフィルター
                  return index >= (page-1)*10 && index < page*10
                })
                .map((marker, index) => (
                  <OverviewCard
                    key={`OverviewCard${index}-bottom`}
                    targetMarker={marker}
                    handleCardClick={handleCardClick}
                    myPlaces={[]}
                  />
                ))}
              </Box>
              <CardPagination
                count={Math.ceil(relevantMarkers?.length / 10)}
                page={page}
                setPage={setPage}              
              />
            </CardContent>
          </Card>
        </Box>
      </Drawer>
      </> 
    );
};
export default BottomDrawer;
